import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_2 = { class: "bg-gray-50" }
const _hoisted_3 = {
  key: 0,
  scope: "col",
  class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_4 = {
  key: 0,
  class: "px-6 py-4 whitespace-nowrap"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-center text-gray-900"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-center text-sm font-medium" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "text-lg mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "col-span-5 mb-4"
}
const _hoisted_14 = { class: "text-gray-400 text-sm mt-1" }
const _hoisted_15 = {
  key: 1,
  class: "col-span-5 mb-4"
}
const _hoisted_16 = ["for"]
const _hoisted_17 = {
  key: 0,
  class: "text-center mt-4 text-red-400 text-sm"
}
const _hoisted_18 = {
  key: 1,
  class: "text-center mt-4 space-x-2"
}
const _hoisted_19 = { class: "text-center mt-4" }

import { computed, nextTick, ref } from 'vue';
import draggable from "vuedraggable";
import ButtonComponent from './ButtonComponent.vue';
import TextInput from './inputs/TextInput.vue';
import { PencilSquareIcon, TrashIcon, PlusIcon, XCircleIcon } from '@heroicons/vue/24/outline';
import DropzoneInput from './inputs/DropzoneInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListTable',
  props: {
    list: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
},
  emits: ['update-list'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const STATUSES = {
    default: 0,
    creating: 1,
    editing: 2,
};

const status = ref(STATUSES.default);

const errors = ref("");

const listData = computed(() => {
    const data = buildModel(true);
    if(data[Object.keys(data)[0]]){
        data.length = data[Object.keys(data)[0]].length
    }  
      return data;
    });

const selectedIndex = ref(null);

function buildModel(populate = false) {
    const obj = {};
    props.items.forEach((item) => {
        obj[`${props.id}_${item.id}`] = populate
            ? props.form[`${props.id}_${item.id}`] ?? []
            : null;
        if (item.type === "image") {
            obj[`${props.id}_${item.id}_file`] = populate
            ? props.form[`${props.id}_${item.id}_file`] ?? []
            : null;
        }
    });
    return obj;
}

const createForm = ref(buildModel());

// validate locally to save bandwidth
function validate() {
      const form = Object.assign({}, createForm.value);
      for (const key in form) {
        const itemKey = key.replace(`${props.id}_`, "");
        const obj = props.items.find((i) => i.id === itemKey);
        if (obj && obj.rules.includes("required") && form[key] === null) {
          // add image rules
          if (obj.type === "image" && form[`${key}_file`] !== null) {
            continue;
          }
          errors.value = `${obj.label} is required.`;
          return false;
        }
      }
      errors.value = "";
      return true;
    }

function edit(index) {
    selectedIndex.value = index;
    props.items.forEach((item) => {
    const key = `${props.id}_${item.id}`;
    createForm.value[key] = props.form[key][index];
    if (item.type === "image") {
        createForm.value[`${key}_file`] = props.form[`${key}_file`][index];
    }
    });
    status.value = STATUSES.editing;
    nextTick(() => {
    document.getElementById(`${props.id}_editor`).scrollIntoView();
    });
}

function remove(index) {
    selectedIndex.value = index;
    emit("update-list", {
    action: "delete",
    form: createForm.value,
    selectedIndex: selectedIndex.value,
    });
    status.value = STATUSES.default;
    selectedIndex.value = null;
}

function save() {
    if (validate()) {
    emit("update-list", {
        action: status.value === STATUSES.creating ? "create" : "edit",
        form: createForm.value,
        selectedIndex: selectedIndex.value,
    });
    createForm.value = buildModel(); // reset form
    status.value = STATUSES.default;
    selectedIndex.value = null;
    }
}

function cancel() {
    status.value = STATUSES.default;
    createForm.value = buildModel(); // reset form
}

function reorder(order) {
    emit("update-list", {
    action: "reorder",
    form: createForm.value,
    order: order,
    });
}

/* TODO: Add storage url */
// const storage_url = computed(() => usePage().props.storage_url);
function renderUrl(url) {
    return url !== null && url.startsWith("data:")
    ? url
    : null;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.summary_field)
                ? (_openBlock(), _createElementBlock("th", _hoisted_3, _toDisplayString(item?.label), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _cache[2] || (_cache[2] = _createElementVNode("th", {
            scope: "col",
            class: "relative px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
          }, " Actions ", -1))
        ])
      ]),
      _createVNode(_unref(draggable), {
        modelValue: [...Array(listData.value.length).keys()],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (reorder($event))),
        tag: "tbody",
        "item-key": "name",
        class: "bg-white divide-y divide-gray-200"
      }, {
        item: _withCtx(({ index }) => [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (item.summary_field)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                      (item.type === 'image')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("img", {
                              class: "m-auto object-contain",
                              src: renderUrl(listData.value[`${__props.id}_${item.id}`][index]),
                              alt: "",
                              width: "120"
                            }, null, 8, _hoisted_6)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(listData.value[`${__props.id}_${item.id}`][index]), 1))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (edit(index)), ["prevent"]),
                class: "mx-1 inline-flex items-center p-1 border border-transparent rounded-full text-gray-600 hover:text-blue-400 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-blue-500"
              }, [
                _createVNode(_unref(PencilSquareIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ], 8, _hoisted_9),
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (remove(index)), ["prevent"]),
                class: "mx-1 inline-flex items-center p-1 border border-transparent rounded-full text-gray-600 hover:text-red-400 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-red-500"
              }, [
                _createVNode(_unref(TrashIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ], 8, _hoisted_10)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (status.value !== STATUSES.default)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `${__props.id}_editor`
        }, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(status.value === STATUSES.creating ? "Add" : "Edit") + " " + _toDisplayString(__props.list.label), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `${item.id}`
            }, [
              (item.type === 'text' || item.type === 'url')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(TextInput, {
                      modelValue: createForm.value[`${__props.id}_${item.id}`],
                      "onUpdate:modelValue": ($event: any) => ((createForm.value[`${__props.id}_${item.id}`]) = $event),
                      label: item.label,
                      id: `${item.id}`
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "id"]),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(item.description), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.type === 'image')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", {
                      for: __props.id,
                      class: "block text-sm font-medium text-gray-700 mb-1"
                    }, _toDisplayString(item.label), 9, _hoisted_16),
                    _createVNode(DropzoneInput, {
                      path: createForm.value[`${__props.id}_${item.id}`],
                      "onUpdate:path": ($event: any) => ((createForm.value[`${__props.id}_${item.id}`]) = $event),
                      file: createForm.value[`${__props.id}_${item.id}` + '_file'],
                      "onUpdate:file": ($event: any) => ((createForm.value[`${__props.id}_${item.id}` + '_file']) = $event),
                      id: `${item.id}`,
                      description: item.description,
                      "overwrite-path": true
                    }, null, 8, ["path", "onUpdate:path", "file", "onUpdate:file", "id", "description"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (status.value !== STATUSES.default && errors.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value), 1))
            : _createCommentVNode("", true),
          (status.value !== STATUSES.default)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(ButtonComponent, {
                  onClick: cancel,
                  type: "button",
                  outlined: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(XCircleIcon), {
                      class: "-ml-0.5 mr-2 h-4 w-4",
                      "aria-hidden": "true"
                    }),
                    _cache[3] || (_cache[3] = _createTextVNode(" Cancel ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(ButtonComponent, {
                  onClick: save,
                  type: "button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PencilSquareIcon), {
                      class: "-ml-0.5 mr-2 h-4 w-4",
                      "aria-hidden": "true"
                    }),
                    _cache[4] || (_cache[4] = _createTextVNode(" Save ", -1))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_11))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      (status.value === STATUSES.default)
        ? (_openBlock(), _createBlock(ButtonComponent, {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (status.value = STATUSES.creating)),
            type: "button"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PlusIcon), {
                class: "-ml-0.5 mr-2 h-4 w-4",
                "aria-hidden": "true"
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" Add ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})